import React from 'react';

export enum AScrimGradientDirection {
  BottomToTop = 'BottomToTop',
  TopToBottom = 'TopToBottom',
  LeftToRight = 'LeftToRight',
}

export interface AScrimGradientProps extends React.HTMLAttributes<HTMLDivElement> {
  direction?: AScrimGradientDirection;
  className?: string;
}